<template>
  <div>
    <div class="text-weight-bold">Versão</div>
    <q-select
      v-model="versao"
      :options="listaVersoes"
      @filter="filterFn"
      @input-value="setModel"
      use-input
      dense
      outlined
      option-label="versao"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-italic text-grey">
            Nenhuma versão encontrada
          </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, watch } from "vue";
import { useStore } from "vuex";

const emit = defineEmits(["enviarVersao"]);
const props = defineProps(["resetar", "model", "sistemaUuid"]);

const store = useStore();

const versao = ref(props.model);
const listaVersoes = ref([]);
const listarVersoes = async () => {
  try {
    const response = await store.dispatch("office/listarVersoes", {
      sistemaUuid: props.sistemaUuid,
    });
    listaVersoes.value = response.data.resultado.dados;
  } catch (error) {
    console.log(error);
  }
};

watch(
  () => versao.value,
  () => {
    if (versao.value != "") {
      emit("enviarVersao", versao.value);
    }
  }
);

watch(
  () => props.model,
  () => {
    versao.value = props.model;
  }
);

watch(
  () => props.resetar,
  () => {
    versao.value = "";
  }
);

function filterFn(val, update) {
  listarVersoes(val);
  setTimeout(() => {
    update();
  }, 1000);
}

function setModel(val) {
  if (val === "") {
    versao.value = val;
  }
}
</script>
